var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabSelectedStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16947 0.0088625C4.59629 -0.0814598 4.66174 0.541091 4.80818 0.853992C5.0325 1.33783 5.27865 1.88297 5.59021 2.30876C6.26943 3.24101 7.363 3.7184 8.3849 4.14098C8.83358 4.73772 8.05465 4.82483 7.67146 5.01189C7.02028 5.32804 6.28809 5.7151 5.80205 6.27315C5.20698 6.957 4.85492 7.88925 4.51529 8.73113C4.38135 8.90211 4.0916 8.8795 3.97633 8.70856C3.83611 8.49889 3.66473 7.87954 3.53075 7.59571C2.85781 6.17317 2.20353 5.66996 0.845092 5.01189C0.664377 4.92482 0.10357 4.75708 0.0412683 4.61516C-0.0335028 4.45063 -0.00856439 4.25708 0.131604 4.14098C0.29985 4.00227 0.916768 3.80872 1.16288 3.68292C2.61479 2.94422 3.04162 2.29585 3.72084 0.818513C3.82674 0.58623 3.91712 0.060455 4.1757 0.00561152L4.16947 0.0088625ZM7.27262 4.38288C5.82389 3.84099 4.83622 2.73135 4.25361 1.27978C3.74264 2.47975 3.12572 3.32808 2.02591 3.99582C1.8016 4.13128 1.50251 4.23131 1.29376 4.36997C1.24703 4.40225 1.20962 4.36356 1.23142 4.47966C2.67396 4.98286 3.6772 6.14735 4.25047 7.5828C4.64617 6.66992 5.13844 5.83445 5.92356 5.22801C6.35043 4.899 6.84579 4.68612 7.26953 4.38288H7.27262Z",
    fill: "#C1F700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabSelectedStar);
export default __webpack_public_path__ + "static/media/tab-selected-star.90b4ee8d4827dd11e40a497e58076e95.svg";
export { ForwardRef as ReactComponent };